
import React, { useEffect, useState } from "react";

const Transactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [transactionsPerPage] = useState(5); // Количество записей на одной странице
  const [loading, setLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null); // Для выделения строки

  // Функция для получения данных из API
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await fetch(
          "/api/Transactions/6"
        );
        if (!response.ok) {
          throw new Error("Ошибка загрузки данных");
        }
        let data = await response.json();

        // Сортировка по полю date в порядке убывания
        data.sort((a, b) => new Date(b.date) - new Date(a.date));

        setTransactions(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  // Вычисление индексов для текущей страницы
  const indexOfLastTransaction = currentPage * transactionsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
  const currentTransactions = transactions.slice(
    indexOfFirstTransaction,
    indexOfLastTransaction
  );

  // Функция смены страницы
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div
      style={{
        textAlign: "center",
        margin: "0",
        padding: "20px",
        backgroundColor: "#121212",
        color: "#ffffff",
        minHeight: "100vh",
      }}
    >
      <h1 style={{ marginBottom: "20px" }}>Transactions</h1>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <table
            style={{
              width: "90%",
              margin: "0 auto",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr>
                {transactions.length > 0 &&
                  Object.keys(transactions[0]).map((key) => (
                    <th
                      key={key}
                      style={{
                        border: "1px solid #333",
                        padding: "10px",
                        backgroundColor: "#333",
                      }}
                    >
                      {key.toUpperCase()}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {currentTransactions.map((transaction, index) => (
                <tr
                  key={index}
                  onClick={() => setSelectedRow(index)} // Выделение строки
                  onMouseEnter={() => setSelectedRow(index)} // Подсветка строки при наведении
                  onMouseLeave={() => setSelectedRow(null)} // Убираем подсветку, если курсор уходит
                  style={{
                    border: "1px solid #333",
                    padding: "10px",
                    backgroundColor:
                      selectedRow === index
                        ? "#6200ea" // Цвет при выделении
                        : index % 2 === 0
                        ? "#222" // Чередование цветов строк
                        : "#444",
                    color: selectedRow === index ? "#fff" : "#ccc",
                    cursor: "pointer", // Указатель при наведении
                  }}
                >
                  {Object.values(transaction).map((value, i) => (
                    <td key={i} style={{ padding: "10px" }}>
                      {value}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          {/* Пагинация */}
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {Array.from(
              { length: Math.ceil(transactions.length / transactionsPerPage) },
              (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => paginate(index + 1)}
                  style={{
                    padding: "10px",
                    backgroundColor:
                      currentPage === index + 1 ? "#007bff" : "#333",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  {index + 1}
                </button>
              )
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Transactions;
